import { render, staticRenderFns } from "./candleChart.vue?vue&type=template&id=377043dc&lang=pug&"
import script from "./candleChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./candleChart.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./candleChart.vue?vue&type=style&index=0&id=377043dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports